<template>

    <div class="MyComments-page">
        <div class="sub-container">
            <div v-if="errors.length > 0"
                 style="background-color: rgba(255,116,116,0.56); border: #ff0e00 solid 2px; padding: 8px">
                <ul style="padding: revert; margin: revert">
                    <li style="list-style: square" v-for="error in errors"> {{ error }}</li>
                </ul>
            </div>
            <div v-if="successes.length > 0"
                 style="background-color: rgba(141,255,116,0.56); border: #00ff04 solid 2px; padding: 8px">
                <ul style="padding: revert; margin: revert">
                    <li style="list-style: square" v-for="success in successes"> {{ success }}</li>
                </ul>
            </div>
            <h1>{{ $t('my_comments') }}</h1>
            <div class="row">
                <div class="col-md-9 col-sm-12">
                    <div class="MyComments-top">
                        <p v-if="comments.data.length > 0">
                            {{comments.data.length}} {{ $t('comments') }}
                        </p>
                        <div class="col-md-12 col-sm-12" v-else>
                            <div class="no-Comments">
                                <div>
                                    <i><img src="/assets/images/no-Comments.svg" alt=""/></i>
                                    <p>{{ $t('You_havent_made_any') }}  <br/>{{ $t('comments_yet') }} </p>
                                </div>
                            </div>
                        </div>
                        <div class="Comments-sort"  v-if="comments.data.length > 0">
                            <span>{{ $t('sort_by') }} </span>
                            <select>
                                <option>{{ $t('newest') }} </option>
                            </select>
                        </div>
                    </div>
                    <my-comments-listing v-for="comment in comments.data" :comment="comment"></my-comments-listing>

                </div>

            </div>
        </div>



    </div>

</template>

<script>
let errors = [];
if (typeof pageErrors !== 'undefined') {
    errors = pageErrors;
}

let successes = [];
if (typeof pageSuccesses !== 'undefined') {
    successes = pageSuccesses;
}

import MyCommentsListing from "@/parts/MyCommentsListing.vue";

export default {
    name: "MyCommentsPage",
    components: {MyCommentsListing},
    props: {
        comments:{
            type:Array,
            default:[]
        }
    },

    data() {
        return {
            errors: errors,
            successes: successes,
        }
    }
}
</script>

<style scoped>

</style>

